<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex">
          <div class="form-group mr-1 flex-grow-1">
            <label>Тип звонков</label>
            <select @change="() => filter.typeIds = []" class="form-control" v-model="filter.type">
              <option value="1">Вх. звонки с мини-формой отказа</option>
              <option disabled value="2">Звонки по отказам у менеджера</option>
              <option disabled value="3">Вх. звонки без заказов и без мини-формы</option>
              <option disabled value="4">Звонки по выполненным заявкам</option>
            </select>
          </div>
          <div class="form-group mr-1 flex-grow-1">
            <label>Статусы</label>
            <multiselect
              class="custom_multiselect"
              v-model="filter.typeIds"
              :options="statusesForSelect[filter.type]"
              placeholder="Выберите статусы"
              track-by="title"
              label="title"
              :showLabels="false"
              :searchable="true"
              :multiple="true">
            </multiselect>
          </div>
          <div class="form-group flex-grow-1 drug_select">
            <label>Препарат</label>
            <DrugSearchNew
              minHeight="41"
              :onSelect="(d) => filter.selectedDrug = d"
            />
          </div>
        </div>
        <div class="flex justify-content-between">
          <div class="flex">
            <div class="form-group">
              <label>Продолжительность более</label>
              <input type="number" v-model="filter.durationMore" class="form-control">
            </div>
            <div class="form-group ml-2">
              <label><input type="checkbox" v-model="filter.hideWORecords"> не показывать звонки без записи</label>
            </div>
          </div>
          <div class="align-self-end">
            <LoadingButton
              title="Показать"
              type="button"
              :loading="loading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords(1)"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="records !== null">
      <div class="card-body">
        <p>Всего записей <strong>{{ paginator?.total ?? 0 }}</strong></p>
        <div v-if="paginator">
          <paginate
            v-model="paginator.current_page"
            :page-count="paginator.last_page"
            :page-range="10"
            :margin-pages="2"
            :click-handler="getRecords"
            :prev-text="'&laquo'"
            :next-text="'&raquo'"
            :container-class="'pagination'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            :active-class="'active green_btn'">
          </paginate>
        </div>
        <template v-if="!loading">
          <table class="table mt-1 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Тип звонка</th>
              <th>Телефон</th>
              <th>Препарат</th>
              <th>Запись</th>
              <th class="comment_block"></th>
              <th>Пользователь</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in records" :key="r.id">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ sortedTypes[r.type_id].title }}</td>
              <td>{{ r.phone_call?.ip_phone?.description }}</td>
              <td>
                <template v-if="r.drug?.id">
                  ({{ r.drug.id }}) {{ r.drug.title }}
                </template>
                <template v-else>
                  {{ r.drug_title }}
                </template>
                <div v-for="c in (r.data?.comments ?? [])" class="border-top mt-1 comments_block">
                  <p class="font-italic">{{ c.text }}</p>
                  <p class="text-muted text-right">{{ c.user_name }}</p>
                </div>
              </td>
              <td>
                <template v-if="r.phone_call?.file_link">
                  <p><strong>{{ r.phone_call.call_duration }}</strong> сек.</p>
                  <PlayAudioByRequest :record="r.phone_call"/>
                </template>
              </td>
              <td>
                <form @submit.prevent="updateRecord($event,'newComment', r)">
                  <input :disabled="savingRecord" :required="+r.status > 1" type="text"
                         placeholder="Комментарий к записи для коллег"
                         name="comment"
                         class="form-control">
                  <input :disabled="savingRecord" :required="+r.status > 1" type="text" v-if="+r.status > 1"
                         name="recordReview"
                         placeholder="независимая оценка"
                         class="form-control">
                  <div class="input-group">
                    <select :disabled="savingRecord"
                            v-model="r.status"
                            class="form-control">
                      <option value="0" disabled>Выберите статус</option>
                      <option value="1">Не требует внимания</option>
                      <option value="2">Требует внимания</option>
                      <option value="3">Высокий приоритет внимания</option>
                      <option value="4">Звонок для примера</option>
                    </select>
                    <div class="input-group-append">
                      <button class="btn btn-outline-success" type="submit">Сохранить</button>
                    </div>
                  </div>
                </form>
              </td>
              <td class="created_td">
                <p>
                  ({{ r.user_id }})
                  <UserName :id="r.user_id"/>
                </p>
                <p>{{ printDate(r.created_at) }}</p>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="paginator">
            <paginate
              v-model="paginator.current_page"
              :page-count="paginator.last_page"
              :page-range="10"
              :margin-pages="2"
              :click-handler="getRecords"
              :prev-text="'&laquo'"
              :next-text="'&raquo'"
              :container-class="'pagination'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'"
              :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import Multiselect from 'vue-multiselect'
import api from "@/api";
import Paginate from 'vuejs-paginate';
import PlayAudioByRequest from "@/views/telephony/components/PlayAudioByRequest.vue";
import UserName from "@/components/users/UserName.vue";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  components: {DrugSearchNew, UserName, PlayAudioByRequest, LoadingButton, Multiselect, Paginate},
  data() {
    return {
      loading: false,
      savingRecord: false,
      paginator: null,
      statusesForSelect: {
        1: this.$platformConstants.customerRequestStatuses,
        2: this.$platformConstants.orderRejectReasons.filter((o) => o.id !== 0),
      },
      filter: {
        hideWORecords: true,
        durationMore: 10,
        type: 1,
        typeIds: [],
        selectedDrug: null,
      },
      sortedTypes: this.$platformConstants.customerRequestStatuses.reduce((acc, t) => {
        acc[t.id] = t;
        return acc;
      }, {}),
      records: null,
    }
  },
  methods: {
    async updateRecord(event, alias, record) {
      if (!record.status || +record.status === 0) return;
      const comment = event?.target?.elements?.comment?.value;
      const recordReview = event?.target?.elements?.recordReview?.value;
      console.log(alias, record, comment, recordReview, record.status);
      if (+record.status > 1) {
        if (!recordReview) {
          toastr['warning']('Введите оценку разговора')
          return;
        }
      }
      if (comment) {
        event.target.elements.comment.value = '';
      }
      if (recordReview) {
        event.target.elements.recordReview.value = '';
      }

      this.savingRecord = true;
      const {data} = await api.post('/new/client/calls/statistics/update', {
        action: 'updateRecord',
        record_id: record.id,
        comment_type: 1,
        comment,
        recordReview,
        status: record.status
      })
      if (data.success) {
        if (data.record) {
          const index = this.records.findIndex((r) => r.id === data.record.id);
          if (index !== -1) {
            this.records[index] = {...this.records[index], ...data.record};
          }
        }
        toastr['success'](data.message || 'сохранено', 'Успешно')
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.savingRecord = false;
    },
    async getRecords(page = 1) {
      this.loading = true;
      const {data: r_data} = await api.post('/new/client/calls/statistics?page=' + page, {
        filter: this.filter
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination?.total ? pagination : null;
        this.records = data;
      } else {
        toastr['warning'](r_data.message ?? 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.form-control {
  height: 42px;
}

.created_td,
.comments_block {
  font-size: 12px;
}

.comment_block {
  width: 35%;
}
</style>
